module.exports = __webpack_public_path__ + "static/media/ic_document_card.4f2a5df5.svg";